import { GENERAL_ROUTES } from 'shared/config/routes/generalRoutes';

export const noAccess = (navigate, type) => {
  // type is a string that will make up the error message
  // "You have no access to this ${type}"
  navigate({ pathname: GENERAL_ROUTES.NO_ACCESS }, { state: { type } });
};
